import { useState } from 'react'

import type { Dispatch, SetStateAction } from 'react'
import type { Filters } from '~/types/filters'

export const DEFAULT_PAGE = 0
export const DEFAULT_PAGE_SIZE = 10
export const DEFAULT_SORT = 'created_at DESC'
export const DEFAULT_SEARCH = {}
export const DEFAULT_FILTERS = {}

export interface IPaginationApi {
  filters: Filters
  orderBy: string
  page: number
  search: Filters
  setFilters: Dispatch<SetStateAction<Filters>>
  setOrderBy: Dispatch<SetStateAction<string>>
  setPage: Dispatch<SetStateAction<number>>
  setSearch: Dispatch<SetStateAction<Filters>>
  setSize: Dispatch<SetStateAction<number>>
  size: number
}

const useTablePagination = (
  entriesName: string,
  defaultFilters?: Record<string, unknown | unknown[]>
): IPaginationApi => {
  const storedItemPerPage = localStorage.getItem(entriesName)

  const [page, setPage] = useState(DEFAULT_PAGE)

  const [orderBy, setOrderBy] = useState(DEFAULT_SORT)

  const [search, setSearch] = useState(DEFAULT_SEARCH)

  const [filters, setFilters] = useState(defaultFilters || DEFAULT_FILTERS)

  const [size, setSize] = useState(storedItemPerPage ? parseInt(storedItemPerPage) : DEFAULT_PAGE_SIZE)

  return { filters, orderBy, page, search, setFilters, setOrderBy, setPage, setSearch, setSize, size }
}

export { useTablePagination }
